import React from 'react';
import PermissionEditorModal from '../../Components/PermissionEditor/PermissionEditorModal';
import { useSecurity } from '../../Contexts/SecurityContext';
import { RolesDataService } from '../../Services/RolesDataService';
import { Permissions } from '../../Security/permissions';

const RolePermissionsModal = ({ role, onHide, onSaved }) => {
    const { appUser } = useSecurity();
    const loadPermissionSet = React.useCallback(
        token => RolesDataService.getRolePermissions(role.roleId, token),
        [role.roleId]
    );
    const savePermissionSet = React.useCallback(
        (permissions, token) => RolesDataService.replaceRolePermissions(role.roleId, permissions, token),
        [role.roleId]
    );

    return (
        <PermissionEditorModal
            permission={Permissions.Security.Roles}
            title={`Role permissions: ${role.roleName || 'Unnamed legacy role'}`}
            description="Select the complete set of direct permissions granted by this role. Groups organize the catalog and are never assigned."
            loadPermissionSet={loadPermissionSet}
            savePermissionSet={savePermissionSet}
            onHide={onHide}
            onSaved={onSaved}
            refreshSecurityAfterSave={role.roleId === appUser?.roleId}
        />
    );
};

export default RolePermissionsModal;
